import { TabsProps } from "antd/lib/tabs";

export const TabItems: TabsProps['items'] = [
  {
    label: '用户登录',
    key: 'login',
  },
];
